export default {
      id: "ic_mybalance_wallet-usage",
      viewBox: "0 0 28 28",
      url: "/" + "images/icons.3.109.2.svg#ic_mybalance_wallet-usage",
      toString: function () {
        return this.url;
      }
    }